
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/giveback",
      function () {
        return require("private-next-pages/nl/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/giveback"])
      });
    }
  